import React from 'react';
import SubHeader from '../Base';
import Container from './style';

const Index = (props) => {
  return <SubHeader {...props} Container={Container} />;
};

export default Index;
